import { EParameters } from '@/utils/setParametersFromParams';

/**
 * Append the target display to a destination URL as the `screen` query param.
 *
 * Login deep-links (`/l/<code>--<DISPLAY>`) must land the user on a specific
 * screen (e.g. IDENTIFICATION). Passing the display through the `screen` URL
 * param lets the normal `setParametersFromParams` -> `setInitialDisplayScreen`
 * flow honour it via its `initialScreen` branch, instead of computing and
 * applying the default screen. Previously the login set the display
 * imperatively, which raced with — and lost to — that default-screen
 * initialisation. Routing it through the URL makes the destination
 * deterministic regardless of timing.
 *
 * @param location destination path, possibly already containing a query string
 * @param display target display value; when falsy the location is returned unchanged
 */
export function appendScreenParam(location: string, display?: string): string {
    if (!display) {
        return location;
    }

    const queryIndex = location.indexOf('?');
    const path = queryIndex === -1 ? location : location.slice(0, queryIndex);
    const existingQuery =
        queryIndex === -1 ? '' : location.slice(queryIndex + 1);

    const params = new URLSearchParams(existingQuery);
    params.set(EParameters.SCREEN, display);

    return `${path}?${params.toString()}`;
}
